import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}
// im sorry for the sin im about to commit here
function sortBy(toSort, key, sortDirection) {
    return [...toSort].sort((a, b) => {
        // NOTE - this is hacky but fine for now
        if (key === 'number') {
            return sortDirection === 'ASC' ? a.number - b.number : b.number - a.number
        }

        if (!('score' in a)) {
            return 1;
        } else if (!('score' in b)) {
            return -1;
        }
        return sortDirection === 'ASC' ? a.score[key] - b.score[key] : b.score[key] - a.score[key]
    });
}
function sortEventArrayBy(teamObj, key, sortDirection) {
    const newObject = { ...teamObj }
    newObject.events = sortBy(newObject.events, key, sortDirection);
    return newObject;

}
function sortTeamArrayBy(eventObj, key, sortDirection) {
    const newObject = { ...eventObj }
    newObject.teams = sortBy(newObject.teams, key, sortDirection);
    return newObject;
}

function generateNumber() {
    return Math.floor(Math.random() * 200) + 1;
}
function numberSuggester(haystack, excludeList = []) {
    const needle = generateNumber()
    if (excludeList.includes(needle) || haystack.includes(needle)) {
        return numberSuggester(haystack, excludeList.concat(needle))
    }
    return needle;
}

// NOTE - need to mutate, nothing is capturing as a variable
function calculatePlacements(standings, accessor, saveKey) {
    // TODO - change this to ordinal / standard / modified / dense
    rankings(standings, accessor).forEach(v => {
        v[saveKey] = v['standard']
    })
    return standings
}
function calculatePlacementsAsMap(standings, accessor, saveKey) {
    // TODO - change this to ordinal / standard / modified / dense
    Object.keys(rankingsAsMap(standings, accessor)).forEach(v => {
        if (standings[v]) {
            standings[v][saveKey] = standings[v]['standard']

        }
    })
    return standings
}
function rankingsAsMap(standings, accessor) {
    const sortedStandings = Object.values(standings).sort(function (a, b) {
        return a[accessor] - b[accessor]
    })
    const scores = sortedStandings.map(v => v[accessor])
    const reversed = scores.slice(0).reverse()
    const unique = scores.filter((x, i) => scores.indexOf(x) === i);
    const result = {};
    for (const [index, t] of sortedStandings.entries()) {
        t['ordinal'] = index + 1;
        t['standard'] = scores.indexOf(t[accessor]) + 1
        t['modified'] = reversed.length - reversed.indexOf(t[accessor])
        t['dense'] = unique.indexOf(t[accessor]) + 1
        t['fractional'] = (n => (
            (scores.indexOf(n) + 1) +
                (reversed.length - reversed.indexOf(n))
        ) / 2)(t[accessor])
        result[t.uid] = t;
    }
    return result;
}

function rankings(standings, accessor) {
    standings.sort(function (a, b) {
        return a[accessor] - b[accessor]
    })
    const scores = standings.map(v => v[accessor])
    const reversed = scores.slice(0).reverse()
    const unique = scores.filter((x, i) => scores.indexOf(x) === i);
    for (const [index, t] of standings.entries()) {
        //if (t.event && t.event.number == '12') {
        //    t['standard'] = 0
        //    continue;
        //}
        t['ordinal'] = index + 1;
        t['standard'] = scores.indexOf(t[accessor]) + 1
        t['modified'] = reversed.length - reversed.indexOf(t[accessor])
        t['dense'] = unique.indexOf(t[accessor]) + 1
        t['fractional'] = (n => (
            (scores.indexOf(n) + 1) +
                (reversed.length - reversed.indexOf(n))
        ) / 2)(t[accessor])
    }
    return standings
}

function scoreSheetCalculation(minutesIngest, secondsIngest, penalties, quiz) {
    const minutes = minutesIngest === '' ? 0 : minutesIngest
    const seconds = secondsIngest === '' ? 0 : secondsIngest

    let time = parseInt(minutes) * 60 + parseInt(seconds)
    for (const key in penalties) {
        if (penalties.hasOwnProperty(key)) {
            const penalty = penalties[key];
            if (penalty.checked === true) {
                let add = parseInt(penalty.value)
                if ('format' in penalty && penalty.format === 'MINUTES') {
                    add = add * 60
                }
                const multiplier = penalty.multiplier ? parseInt(penalty.multiplier) : 1
                time += (add * multiplier)
            }
        }
    }

    time += quiz * 30

    time = Math.max(time, 0)
    return Math.min(time, 1500)
}
function getFinalScoresByTeam(scoresMap, teamsMap, eventsMap) {
    let allEvents = {}
    const totalObject = Object.keys(scoresMap).reduce((acc, v) => {

        const eventUid = scoresMap[v]['eventUid']
        const event = eventsMap[eventUid]
        if (!event || event['excludeEvent']) {
            return acc
        }

        const teamUid = scoresMap[v]['teamUid']
        if (!teamUid || !teamsMap[teamUid]) {
            return acc
        }
        if (!(teamUid in acc)) {
            acc[teamUid] = {
                team: teamsMap[teamUid],
                scores: [],
                finalScore: 0
            }
        }
        //if (scoresMap[v]['team']['teamNumber'] == '5') {
        //    allEvents[scoresMap[v]['event']['number']] = scoresMap[v]['event']['number'] in allEvents ? allEvents[scoresMap[v]['event']['number']] +scoresMap[v]['finalScore']: scoresMap[v]['finalScore']
        //    //console.log('team 23 score', scoresMap[v])
        //    //console.log('the score we are on', scoresMap[v]['finalScore'], 'event number ->',scoresMap[v]['event']['number'] )
        //    ////console.log('about to enter', parseInt(acc[teamUid]['finalScore']) + parseInt(scoresMap[v]['finalScore']))
        //    //console.log('team 23 calculated score ', acc[teamUid]['finalScore'] + parseInt(scoresMap[v]['finalScore']))
        //    console.log('team 5 calculated score ',parseInt(acc[teamUid]['finalScore']) + parseInt(scoresMap[v]['finalScore']))
        //}
        const finalScore = Number(scoresMap[v]['finalScore']) || 0
        acc[teamUid]['finalScore'] = Number(acc[teamUid]['finalScore']) + finalScore
        acc[teamUid]['scores'] = acc[teamUid]['scores'].concat(scoresMap[v])

        return acc
    }, {})
    console.log('all our event numbers',allEvents)

    return totalObject
}
function groupedEventsScores(scoresMap, eventsMap, teamsMap = null) {
    const totalObject = Object.keys(scoresMap).reduce((acc, v) => {
        const eventUid = scoresMap[v]['eventUid']
        const event = eventsMap[eventUid]
        if (!event || event['excludeEvent']) {
            return acc
        }
        const teamUid = scoresMap[v]['teamUid']
        if (!teamUid) {
            return acc
        }
        if (teamsMap && !teamsMap[teamUid]) {
            return acc
        }

        if (!(eventUid in acc)) {
            acc[eventUid] = {
                event,
                scores: []
            }
        }
        acc[eventUid]['scores'] = acc[eventUid]['scores'].concat({...scoresMap[v], scoreUid: v})

        return acc
    }, {})

    return totalObject
}

function avgByCategoryInEvent(eventScores, categoriesMap) {
    const totalObject = Object.keys(categoriesMap).reduce((accCategory, c) => {
        accCategory = Object.keys(eventScores).reduce((accEvent, e) => {
            accEvent[e] = eventScores[e]
            if (!('categoriesAvg' in accEvent[e])) {
                accEvent[e]['categoriesAvg'] = {}
            }
            if (!(c in accEvent[e]['categoriesAvg'])) {
                accEvent[e]['categoriesAvg'][c] = 0
            }
            // exclude marker rows from averages
            const scoresMatchingCategory = (eventScores[e]['scores'] || []).filter(x => x && x.team && x.team.category == c && !x.excludeScore && !x.scoreMax)
            if (scoresMatchingCategory.length == 0) {
                return accEvent
            }
            const cateogryAverage = Math.round((scoresMatchingCategory.reduce((total, currentScore) => {
                const finalScore = !currentScore.finalScore || currentScore.finalScore == '0' ? 0 : Number(currentScore.finalScore)
                total = finalScore + total

                return total
            }, 0) / scoresMatchingCategory.length) * 10) / 10

            accEvent[e]['categoriesAvg'][c] = cateogryAverage

            return accEvent
        }, {})
        return accCategory
    }, {})
    return totalObject
}

function avgByDivisionInEvent(eventScores, divisionsMap) {
    const totalObject = Object.keys(divisionsMap).reduce((accDivision, d) => {
        accDivision = Object.keys(eventScores).reduce((accEvent, e) => {
            accEvent[e] = eventScores[e]
            if (!('divisionsAvg' in accEvent[e])) {
                accEvent[e]['divisionsAvg'] = {}
            }
            if (!(d in accEvent[e]['divisionsAvg'])) {
                accEvent[e]['divisionsAvg'][d] = 0
            }
            // exclude marker rows from division averages
            const scoresMatchingCategory = (eventScores[e]['scores'] || []).filter(x => x && x.team && x.team.division == d && !x.excludeScore && !x.scoreMax)
            if (scoresMatchingCategory.length == 0) {
                return accEvent
            }
            const divisionAverage = Math.round((scoresMatchingCategory.reduce((total, currentScore) => {
                const finalScore = !currentScore.finalScore || currentScore.finalScore == '0' ? 0 : Number(currentScore.finalScore)
                total = finalScore + total

                return total
            }, 0) / scoresMatchingCategory.length) * 10) / 10

            accEvent[e]['divisionsAvg'][d] = divisionAverage

            return accEvent
        }, {})
        return accDivision
    }, {})
    return totalObject
}
function avgOverallInEvent(eventScores) {
    const totalObject = Object.keys(eventScores).reduce((accEvent, e) => {
        accEvent[e] = eventScores[e]
        if (!('avgOverall' in accEvent[e])) {
            accEvent[e]['avgOverall'] = 0
        }
        // exclude marker rows (excludeScore and scoreMax) from overall average
        const validScores = (accEvent[e]['scores'] || []).filter(s => !s.excludeScore && !s.scoreMax)
        if (validScores.length === 0) {
            accEvent[e]['avgOverall'] = 0
            return accEvent
        }
        const total = Math.round((validScores.reduce((accScores, s) => {
            const finalScore = !s.finalScore || s.finalScore == '0' ? 0 : Number(s.finalScore)
            accScores = finalScore + accScores
            return accScores
        }, 0) / validScores.length) * 10) / 10
        accEvent[e]['avgOverall'] = total
        return accEvent
    }, {})
    return totalObject
}
function getOverallTopInEvent(eventScores) {
    const totalObject = Object.keys(eventScores).reduce((accEvent, e) => {
        accEvent[e] = eventScores[e]
        if (!('overallTopInEvent' in accEvent[e])) {
            accEvent[e]['overallTopInEvent'] = 0
        }
        const nonExcludedForTop = (eventScores[e]['scores'] || []).filter(s => !s.excludeScore && !s.scoreMax);
        const bestScore = nonExcludedForTop.length > 0 ? Math.min(...nonExcludedForTop.map(v => v.finalScore)) : Math.min(...(eventScores[e]['scores'] || []).map(v => v.finalScore));
        accEvent[e]['overallTopInEvent'] = bestScore

        return accEvent
    }, {})
    return totalObject
}

function getCategoryTopOverallInEvent(eventScores, categories) {
    const totalObject = Object.keys(categories).reduce((accCategory, c) => {
        accCategory = Object.keys(eventScores).reduce((accEvent, e) => {
            accEvent[e] = eventScores[e]
            if (!('categoryTop' in accEvent[e])) {
                accEvent[e]['categoryTop'] = {}
            }
            if (!(c in accEvent[e]['categoriesAvg'])) {
                accEvent[e]['categoryTop'][c] = 0
            }
            const categoryScores = (eventScores[e]['scores'] || []).filter(x => x && x.team && x.team.category == c && !x.excludeScore && !x.scoreMax).map(x => x.finalScore);
            const bestScoreInCategory = categoryScores.length > 0 ? Math.min(...categoryScores) : NaN;
            accEvent[e]['categoryTop'][c] = Number.isFinite(bestScoreInCategory) ? bestScoreInCategory : -1

            return accEvent
        }, {})
        return accCategory
    }, {})

    return totalObject
}

// NOTE - allowing for mutation
// options: { affiliatedMode: 'none'|'average'|'max', teamModes: { [teamUid]: mode } }
function getEventCategoryPlaceInEvent(eventScores, categories, options = {}) {
    const { affiliatedMode = 'none', teamModes = {}, manualOverrides = {} } = options;
    Object.keys(categories).forEach((categoryKey) => {
        Object.keys(eventScores).forEach((eventId) => {
            const event = eventScores[eventId];
            const scores = event.scores || [];
            const associatedUids = (event.event?.associatedTeams || []).map(a => (typeof a === 'string' ? a : a.uid));
            const avgAffiliated = event.avgOverall;
            const nonExcluded = (event.scores || []).filter(s => !s.excludeScore && !s.scoreMax);
            const eventMax = nonExcluded.length > 0
                ? Math.max(...nonExcluded.map(s => Number(s.finalScore || 0)))
                : (scores.length > 0 ? Math.max(...scores.map(s => Number(s.finalScore || 0))) : 0);
            const sortedNonAffScores = nonExcluded
                .filter(s => !associatedUids.includes(s.teamUid))
                .map(s => Number(s.finalScore || 0))
                .sort((a, b) => a - b);

            const regularCategoryScores = scores.filter(
                (x) => x && x.team && x.team.category === categoryKey
            );
            calculatePlacements(regularCategoryScores, 'finalScore', 'categoryPlace');

            // Apply affiliated adjustments according to options and per-team overrides
            const affiliatedCategoryScores = scores
            .filter((x) => x && x.team && x.team.category === categoryKey)
            .map((score) => {
                const isAffiliated = associatedUids.includes(score.teamUid);
                let finalScoreAssociated = score.finalScore;

                // per-team exclude overrides everything
                const perTeamMode = teamModes?.[score.teamUid] || 'normal';
                const isManuallyOverridden = manualOverrides && manualOverrides[score.teamUid];
                if (isAffiliated && perTeamMode === 'exclude') {
                    finalScoreAssociated = 1500;
                } else if (isAffiliated) {
                    // determine effective mode: per-team overrides (if they are affiliated_*), otherwise global affiliatedMode
                    let effectiveMode = 'none';
                    if (perTeamMode && perTeamMode.startsWith('affiliated_')) {
                        effectiveMode = perTeamMode.replace(/^affiliated_/, '');
                    } else if (isManuallyOverridden && perTeamMode === 'normal') {
                        // user explicitly set this team's mode to normal -> do not apply global affiliatedMode
                        effectiveMode = 'none';
                    } else {
                        effectiveMode = affiliatedMode;
                    }

                    if (effectiveMode === 'average') {
                        if (typeof avgAffiliated === 'number' && Number(score.finalScore || 0) < avgAffiliated) {
                            finalScoreAssociated = avgAffiliated;
                        }
                    } else if (effectiveMode === 'max') {
                        finalScoreAssociated = eventMax;
                    } else if (effectiveMode === 'up_next') {
                        const orig = Number(score.finalScore || 0);
                        const next = sortedNonAffScores.find(sc => sc > orig);
                        finalScoreAssociated = next !== undefined ? next : orig;
                    }
                }

                return {
                    ...score,
                    finalScoreAssociated
                };
            });

            // Mutate the original scores to include finalScoreAssociated
            affiliatedCategoryScores.forEach((s) => {
                const original = scores.find((x) => x.uid === s.uid); // match back by unique score ID
                if (original) {
                    original.finalScoreAssociated = s.finalScoreAssociated;
                }
            });

            calculatePlacements(
                affiliatedCategoryScores,
                'finalScoreAssociated',
                'categoryPlaceAssociated'
            );
        });
    });
}


// NOTE - allowing for mutation
// options: { affiliatedMode: 'none'|'average'|'max', teamModes: { [teamUid]: mode } }
function getPlacementOverallInEvent(eventScores, options = {}) {
    const { affiliatedMode = 'none', teamModes = {}, manualOverrides = {} } = options;
    Object.keys(eventScores).reduce((accEvent, e) => {
        accEvent[e] = eventScores[e]
        const toAnalyze = eventScores[e]['scores'] || []
 
        const associatedUids = (accEvent[e].event?.associatedTeams || []).map(a => (typeof a === 'string' ? a : a.uid)); 
        let avgScore = accEvent[e].avgOverall;
        const nonExcluded = (accEvent[e].scores || []).filter(s => !s.excludeScore && !s.scoreMax);
        const eventMax = nonExcluded.length > 0
            ? Math.max(...nonExcluded.map(s => Number(s.finalScore || 0)))
            : (toAnalyze.length > 0 ? Math.max(...toAnalyze.map(s => Number(s.finalScore || 0))) : 0);
        const sortedNonAffScores = nonExcluded
            .filter(s => !associatedUids.includes(s.teamUid))
            .map(s => Number(s.finalScore || 0))
            .sort((a, b) => a - b);

        toAnalyze.forEach((score) => {
            let finalScoreAssociated = score.finalScore;
            const isAffiliated = associatedUids.includes(score.teamUid);
            const perTeamMode = teamModes?.[score.teamUid] || 'normal';
            const isManuallyOverridden = manualOverrides && manualOverrides[score.teamUid];
            if (isAffiliated && perTeamMode === 'exclude') {
                finalScoreAssociated = 1500;
            } else if (isAffiliated) {
                let effectiveMode = 'none';
                if (perTeamMode && perTeamMode.startsWith('affiliated_')) {
                    effectiveMode = perTeamMode.replace(/^affiliated_/, '');
                } else if (isManuallyOverridden && perTeamMode === 'normal') {
                    effectiveMode = 'none';
                } else {
                    effectiveMode = affiliatedMode;
                }

                if (effectiveMode === 'average') {
                    if (typeof avgScore === 'number' && Number(score.finalScore || 0) < avgScore) {
                        finalScoreAssociated = avgScore;
                    }
                } else if (effectiveMode === 'max') {
                    finalScoreAssociated = eventMax;
                } else if (effectiveMode === 'up_next') {
                    const orig = Number(score.finalScore || 0);
                    const next = sortedNonAffScores.find(sc => sc > orig);
                    finalScoreAssociated = next !== undefined ? next : orig;
                }
            }
 
            score.finalScoreAssociated = finalScoreAssociated;
        });
 
        calculatePlacements(toAnalyze, 'finalScoreAssociated', 'overallPlaceAssociated')
        calculatePlacements(toAnalyze, 'finalScore', 'overallPlace')

        // compute division placements (per-event)
        try {
            const divisions = Array.from(new Set((toAnalyze || []).map(s => s.team && s.team.division).filter(Boolean)));
            divisions.forEach(divId => {
                const group = (toAnalyze || []).filter(s => (s.team && s.team.division) === divId);
                if (!group || group.length === 0) return;
                calculatePlacements(group, 'finalScore', 'divisionPlace');
                calculatePlacements(group, 'finalScoreAssociated', 'divisionPlaceAssociated');
            });
        } catch (e) {
            // defensive: ignore
        }
        return accEvent
    }, {})
}

// NOTE - allowing for mutation
// options: { affiliatedMode: 'none'|'average'|'max', teamModes: { [teamUid]: mode } }
function getPlacementOverAllEventsAndCategories(eventScores, teamsMap, categoriesMap, options = {}) {
    const { affiliatedMode = 'none', teamModes = {}, manualOverrides = {} } = options;
    // Reset scores
    Object.keys(teamsMap).forEach((t) => {
        teamsMap[t].uid = t;
        teamsMap[t].finalScore = 0;
        teamsMap[t].finalScoreAssociated = 0;
    });

    // Aggregate scores per team
    Object.keys(eventScores).forEach((e) => {
        const event = eventScores[e];
        if (!event) {
            return;
        }
        const scores = event.scores || [];
        const avgAffiliated = event.avgOverall;
        const associatedUids = (event.event?.associatedTeams || []).map(a => (typeof a === 'string' ? a : a.uid));
        const nonExcluded = scores.filter(s => !s.excludeScore && !s.scoreMax);
        const eventMax = nonExcluded.length > 0
            ? Math.max(...nonExcluded.map(s => Number(s.finalScore || 0)))
            : (scores.length > 0 ? Math.max(...scores.map(s => Number(s.finalScore || 0))) : 0);
        const sortedNonAffScores = nonExcluded
            .filter(s => !associatedUids.includes(s.teamUid))
            .map(s => Number(s.finalScore || 0))
            .sort((a, b) => a - b);

        scores.forEach((s) => {
            if (!s || !s.teamUid) return;
            const t = s.teamUid;
            if (!teamsMap[t]) return;
            const finalScore = !s.finalScore || s.finalScore === '0' ? 0 : Number(s.finalScore);

            // Regular scoring
            teamsMap[t].finalScore += finalScore;

            // Determine adjusted score for affiliated logic
            const isAffiliated = associatedUids.includes(t);
            const perTeamMode = teamModes?.[t] || 'normal';
            const isManuallyOverridden = manualOverrides && manualOverrides[t];
            let adjustedScore = finalScore;
            if (isAffiliated && perTeamMode === 'exclude') {
                adjustedScore = 1500;
            } else if (isAffiliated) {
                let effectiveMode = 'none';
                if (perTeamMode && perTeamMode.startsWith('affiliated_')) {
                    effectiveMode = perTeamMode.replace(/^affiliated_/, '');
                } else if (isManuallyOverridden && perTeamMode === 'normal') {
                    effectiveMode = 'none';
                } else {
                    effectiveMode = affiliatedMode;
                }

                if (effectiveMode === 'average') {
                    if (typeof avgAffiliated === 'number' && Number(finalScore) < avgAffiliated) {
                        adjustedScore = avgAffiliated;
                    }
                } else if (effectiveMode === 'max') {
                    adjustedScore = eventMax;
                } else if (effectiveMode === 'up_next') {
                    const next = sortedNonAffScores.find(sc => sc > finalScore);
                    adjustedScore = next !== undefined ? next : finalScore;
                }
            }

            teamsMap[t].finalScoreAssociated += adjustedScore;
        });

        // If there are affiliated teams that did not submit a score, ensure they are
        // included in the adjusted totals when their per-team mode indicates exclusion
        // (or other behaviors should be applied). This ensures a team set to 'exclude'
        // is counted as 1500 for every affiliated event, even when a submission is missing.
        try {
            const processed = new Set(scores.map(s => s && s.teamUid).filter(Boolean));
            const missingAffiliated = associatedUids.filter(u => !processed.has(u));
            missingAffiliated.forEach((uid) => {
                // ensure the team exists in teamsMap; if not, skip
                if (!teamsMap[uid]) return;
                const perTeamMode = teamModes?.[uid] || 'normal';
                const isManuallyOverridden = manualOverrides && manualOverrides[uid];
                // for missing submissions, regular finalScore contribution is 0
                const finalScore = 0;
                // apply same logic as above for adjusted score
                if (perTeamMode === 'exclude') {
                    teamsMap[uid].finalScoreAssociated += 1500;
                } else if (perTeamMode && perTeamMode.startsWith('affiliated_')) {
                    const effectiveMode = perTeamMode.replace(/^affiliated_/, '');
                    if (effectiveMode === 'average') {
                        if (typeof avgAffiliated === 'number' && finalScore < avgAffiliated) {
                            teamsMap[uid].finalScoreAssociated += avgAffiliated;
                        }
                    } else if (effectiveMode === 'max') {
                        teamsMap[uid].finalScoreAssociated += eventMax;
                    } else {
                        // up_next with no submission: no adjustment
                        teamsMap[uid].finalScoreAssociated += finalScore;
                    }
                } else if (isManuallyOverridden && perTeamMode === 'normal') {
                    // explicit manual normal -> do not apply global affiliatedMode
                    teamsMap[uid].finalScoreAssociated += finalScore;
                } else if (affiliatedMode === 'average') {
                    if (typeof avgAffiliated === 'number' && finalScore < avgAffiliated) {
                        teamsMap[uid].finalScoreAssociated += avgAffiliated;
                    }
                } else if (affiliatedMode === 'max') {
                    teamsMap[uid].finalScoreAssociated += eventMax;
                } else {
                    teamsMap[uid].finalScoreAssociated += finalScore;
                }
            });
        } catch (e) {
            // defensive: ignore if event.scores is malformed
            console.error('Error applying missing affiliated adjustments', e);
        }
    });

    calculatePlacementsAsMap(teamsMap, 'finalScore', 'place');
    calculatePlacementsAsMap(teamsMap, 'finalScoreAssociated', 'placeAssociated');

    Object.keys(categoriesMap).forEach((c) => {
        const matchingRegular = {};
        const matchingAssociated = {};

        Object.keys(teamsMap).forEach((t) => {
            const team = teamsMap[t];
            if (team.category === c) {
                if (team.finalScore !== 0) {
                    matchingRegular[t] = team;
                }
                if (team.finalScoreAssociated !== 0) {
                    matchingAssociated[t] = team;
                }
            }
        });

        calculatePlacementsAsMap(matchingRegular, 'finalScore', 'categoryPlace');
        calculatePlacementsAsMap(matchingAssociated, 'finalScoreAssociated', 'categoryPlaceAssociated');
    });
}


const SCORESHEET_STATES = {
    CREATED: 'CREATED',
    SUBMITTED: 'SUBMITTED',
    EDIT_REQUESTED: 'EDIT_REQUESTED',
    APPROVED: 'APPROVED',
    LOCKED: 'LOCKED',
}
const ROLES = {
    ADMIN: "ADMIN",
    SCORECOMMITTEE: "SCORECOMMITTEE",
    JUDGE: "JUDGE",
    TEAM: "TEAM"
}

const REGISTRATION_STATES = {
    SUBMITTED: "SUBMITTED",
    READY_TO_PUSH: "READY_TO_PUSH",
    PUSHED: "PUSHED",
    NOT_PUSHED: "NOT_PUSHED"
}

const determineScoresheetTableChipColor = (status) => {
    switch (status) {
        case SCORESHEET_STATES.CREATED:
            return 'primary' // BLUE
        case SCORESHEET_STATES.SUBMITTED:
            return 'secondary' // PINK
        case SCORESHEET_STATES.APPROVED:
            return 'success' // GREEN
        case SCORESHEET_STATES.LOCKED:
            return ''
        case SCORESHEET_STATES.EDIT_REQUESTED:
            return 'warning' // YELLOW
        default:
            return ''
    }
}

export {
    withRouter,
    sortEventArrayBy,
    sortTeamArrayBy,
    numberSuggester,
    calculatePlacements,
    calculatePlacementsAsMap,
    scoreSheetCalculation,
    getFinalScoresByTeam,
    groupedEventsScores,
    avgByCategoryInEvent,
    avgByDivisionInEvent,
    avgOverallInEvent,
    getOverallTopInEvent,
    getCategoryTopOverallInEvent,
    getEventCategoryPlaceInEvent,
    getPlacementOverallInEvent,
    getPlacementOverAllEventsAndCategories,
    SCORESHEET_STATES,
    ROLES,
    REGISTRATION_STATES,
    determineScoresheetTableChipColor
}
